import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import {browserId, sub, toTopic, unSub} from "@/lib/session";
import {editor} from "@/app/editor";
import {WechatOutlined} from "@ant-design/icons-vue";
import emit from "@/lib/emit";


export default /*#__PURE__*/_defineComponent({
  __name: 'WxUploaderButton',
  emits: ['on-upload-image'],
  setup(__props, { emit: __emit }) {


const emits = __emit

const onUploadWxChange = (open: boolean) => {
  if (open) {
    sub(editor.activity?.id ?? '')
    emit.on(toTopic(editor.activity?.id ?? ''), (o) => {
      emits('on-upload-image', o.url)
    })
  } else {
    unSub(editor.activity?.id ?? '')
    emit.off(toTopic(editor.activity?.id ?? ''))
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createBlock(_component_a_popover, {
    trigger: "click",
    onOpenChange: onUploadWxChange
  }, {
    content: _withCtx(() => [
      _createVNode(_component_a_flex, {
        vertical: "",
        gap: "middle",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: `https://api.activity.djhdb.cn/pc/open/qr/upload?id=${_unref(browserId)+'/'+_unref(editor).activity?.id}`,
            width: "180px",
            alt: "qr"
          }, null, 8, _hoisted_1),
          _createVNode(_component_a_typography_text, null, {
            default: _withCtx(() => [
              _createTextVNode("上传完成列表自动更新")
            ]),
            _: 1
          }),
          _createVNode(_component_a_typography_text, {
            type: "secondary",
            style: {"margin-top":"-16px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("上传时不要关闭此码")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_button, { type: "primary" }, {
        default: _withCtx(() => [
          _createVNode(_unref(WechatOutlined)),
          _createTextVNode(" 微信扫码上传 ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})